import { ReactNode } from 'react';

import { ProgressT } from '../types';

export const PlaceholderComponent: React.FC<{ title: ReactNode; }> = ({ title }) => (
  <div>{title}</div>
);

export const redirectTo = (url: string, replace?: boolean) => {
  // istanbul ignore next -- @preserve
  replace ? window.location.replace(url) : (window.location.href = url);
};

export const normalizeProgressValues = ({
  current,
  total,
}: ProgressT): ProgressT => {
  const normalizedTotal = Math.max(0, total);
  const normalizedCurrent = Math.min(
    normalizedTotal,
    Math.max(0, current),
  );

  return {
    current: normalizedCurrent,
    total: normalizedTotal,
  };
};
